import { render, staticRenderFns } from "./GroupsCrud.vue?vue&type=template&id=f5cb9f78"
import script from "./GroupsCrud.vue?vue&type=script&lang=js"
export * from "./GroupsCrud.vue?vue&type=script&lang=js"
import style0 from "./GroupsCrud.vue?vue&type=style&index=0&id=f5cb9f78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports